import { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';

/**
 * Hook to listen to a template document live by its ID and issuer ID.
 * 
 * @param {string} templateTagId - The ID of the template_tag document
 * @param {string} issuerId - The ID of the issuer (defaults to 'strike')
 * @returns {[boolean, Object, any]} [loading, template, error]
 */
export function useTemplate(templateTagId, issuerId = 'strike') {
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(!!templateTagId);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!templateTagId) {
      setTemplate(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    const db = firebase.firestore();

    const docRef = db.collection('issuers').doc(issuerId).collection('template_tags').doc(templateTagId);

    const unsubscribe = docRef.onSnapshot((snap) => {
      if (snap.exists) {
        setTemplate({ id: snap.id, ...snap.data() });
      } else {
        console.warn(`Template ${templateTagId} not found under issuer ${issuerId}`);
        setTemplate(null);
      }
      setLoading(false);
    }, (err) => {
      console.error("useTemplate snapshot error:", err);
      setError(err);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, [templateTagId, issuerId]);

  return [loading, template, error];
}
